import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { UsersListFilter, UserSummaryListFilter } from "@shared/interfaces";

export default {
  getUsersList: (payload: UsersListFilter) => request(METHODS.GET, API.USER.GET_USERS_LIST)({ params: payload }),
  getUsersListSummary: (payload: UserSummaryListFilter) =>
    request(METHODS.GET, API.USER.GET_USERS_LIST_SUMMARY)({ params: payload }),
};
